import {AxiosProcessor} from "../../shared/axios/AxiosProcessor";
const urlDocument = '/documentFile';

const state = {
    documentFile: {},
    documentFiles: [],
    action: null,
    documentFilesLastEvaluatedKey: null
};

const getters = {
    getDocumentFile: state => {
        return state.documentFile;
    },
    getDocumentFiles: state => {
        return state.documentFiles;
    },
    getDocumentFilesLastEvaluatedKey: state => {
        return state.documentFilesLastEvaluatedKey;
    },
};

const mutations = {
    setDocumentFile: (state, data) => {
        state.documentFile = data;
    },
    setAction: (state, data) => {
        state.action = data;
    },
    setDocumentFiles: (state, data) => {
        state.documentFiles = data;
    },
    setDocumentFilesLastEvaluatedKey: (state, data) => {
        state.documentFilesLastEvaluatedKey = data;
    }
};

const actions = {
     setDocumentFile: async ({commit}, data) => {
        //going backend
        let value = {};

        if(!!!data.id) {
            value  = await AxiosProcessor.post(urlDocument, data);
        }
        else {
            value = await AxiosProcessor.put(urlDocument+'/'+ data.id, data);
        }

        commit('setDocumentFile', value);
    },
    async getDocumentFile ({commit}, data) {

        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
        if(state.documentFile.id && state.documentFile.id === id)
            return;

        let documentFile;
        let value = {};

        if (state.documentFiles.length > 0) {
            documentFile  = state.documentFiles.find(doc => doc.id === id);
        }

        if(documentFile)
        {
            value = documentFile;
        }
        else
        {
            let response = await AxiosProcessor.get(urlDocument + '/' + id);

            if (response.Item)
                value = response.Item;
        }

        commit('setDocumentFile', value);
    },
    async inactivateDocumentFiles({commit}, data){
         let value = {};

         value = await AxiosProcessor.post(urlDocument +'/action/'  + data.action, data);

         commit('setAction', value);
    },
    async getDocumentFiles ({commit}, params) {
        //going backend,
        let value = [];

        let response = await AxiosProcessor.list(urlDocument,params);

        if(response.Items)
            value = response.Items;

        if(response.LastEvaluatedKey)
            commit('setDocumentFilesLastEvaluatedKey', response.LastEvaluatedKey);
        else
            commit('setDocumentFilesLastEvaluatedKey', null);

        commit('setDocumentFiles', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}